// TeamCard.js
import React, { useState } from "react";
import styled from "styled-components";
import "./Team.css";

// Card Wrapper
const Card = styled.div`
  padding: 20px;
  background: #faf3f0;
  border-radius: 10px;
  text-align: justify;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s;
  &:hover {
    transform: translateY(-10px);
  }
  height: fit-content;
`;

const ImageWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;

// Image Styling
const Image = styled.img`
  width: 120px;
  height: 120px;
  border-radius: 50%;
  margin-bottom: 15px;
  object-fit: cover;
`;

// Name Styling
const Name = styled.h3`
  font-size: 1.4rem;
  color: #333;
  margin-bottom: 10px;
  text-align: center;
`;

// Designation Styling
const Designation = styled.p`
  font-size: 1rem;
  color: #777;
  margin-bottom: 15px;
  text-align: center;
`;

// Introduction Styling
const Intro = styled.p`
  font-size: 0.9rem;
  color: #555;
`;

const TeamCard = ({ member, isTestemonials, staffCard }) => {
  const { image, name, designation, intro, detailedIntro } = member;
  const [showDetailedIntro, setShowDetailedIntro] = useState(false);
  return staffCard ? (
    <Card>
      {!isTestemonials && (
        <ImageWrapper>
          <Image src={image} alt={name} />
        </ImageWrapper>
      )}

      <Name>{name}</Name>
      <Designation>{designation}</Designation>
      <Intro>
        <ul>
          {member.staffList.map((item) => {
            return <li>{item}</li>;
          })}
        </ul>
      </Intro>
    </Card>
  ) : (
    <Card>
      {!isTestemonials && (
        <ImageWrapper>
          <Image src={image} alt={name} />
        </ImageWrapper>
      )}
      <div
        style={{
          height: "130px",
        }}
      >
        <Name>{name}</Name>
        <Designation>{designation}</Designation>
      </div>
      <div
        style={{
          height: showDetailedIntro ? "100%" : "240px",
          overflow: "hidden",
        }}
      >
        <Intro>
          {/* {showDetailedIntro ? detailedIntro : detailedIntro.slice(0, 270)} */}
          {detailedIntro}
        </Intro>
      </div>
      <div>
        <button
          style={{
            outline: "none",
            border: "none",
            backgroundColor: "transparent",
            color: "#0d6efd",
          }}
          onClick={() => {
            setShowDetailedIntro(!showDetailedIntro);
          }}
        >
          {name != "Mr. NIDHISH GOYAL" &&
            (showDetailedIntro ? "...read less" : "...read more")}
        </button>
      </div>
    </Card>
  );
};

export default TeamCard;
